var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10831_109970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2033 119.849C62.7354 120.051 57.2674 120.051 51.7994 119.849C23.733 118.818 1.18145 96.2664 0.150195 68.2023C-0.0513672 62.7344 -0.0513672 57.2664 0.150195 51.7984C1.18145 23.732 23.733 1.18047 51.7971 0.149219C57.265 -0.0523438 62.733 -0.0523438 68.201 0.149219C96.265 1.18047 118.819 23.732 119.848 51.7961C120.049 57.2641 120.049 62.732 119.848 68.2C118.817 96.2641 96.265 118.818 68.201 119.847L68.2033 119.849Z",
    fill: "url(#paint0_radial_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2033 119.849C62.7354 120.051 57.2674 120.051 51.7994 119.849C23.733 118.818 1.18145 96.2664 0.150195 68.2023C-0.0513672 62.7344 -0.0513672 57.2664 0.150195 51.7984C1.18145 23.732 23.733 1.18047 51.7971 0.149219C57.265 -0.0523438 62.733 -0.0523438 68.201 0.149219C96.265 1.18047 118.819 23.732 119.848 51.7961C120.049 57.2641 120.049 62.732 119.848 68.2C118.817 96.2641 96.265 118.818 68.201 119.847L68.2033 119.849Z",
    fill: "url(#paint1_radial_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0004 101.96C65.2441 101.96 69.4949 97.2787 69.4949 91.5043C69.4949 85.7299 65.2441 81.0488 60.0004 81.0488C54.7567 81.0488 50.5059 85.7299 50.5059 91.5043C50.5059 97.2787 54.7567 101.96 60.0004 101.96Z",
    fill: "url(#paint2_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0003 77.3293C65.344 77.3293 70.2518 80.498 74.1073 85.7879C75.1479 87.2152 77.4073 86.1371 76.9409 84.4309C74.18 74.3598 69.4573 67.748 60.0003 67.748C50.5433 67.748 45.8206 74.3598 43.0597 84.4309C42.5933 86.1348 44.8526 87.2152 45.8933 85.7879C49.7487 80.498 54.6565 77.3293 60.0003 77.3293Z",
    fill: "url(#paint3_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0003 77.3293C65.344 77.3293 70.2518 80.498 74.1073 85.7879C75.1479 87.2152 77.4073 86.1371 76.9409 84.4309C74.18 74.3598 69.4573 67.748 60.0003 67.748C50.5433 67.748 45.8206 74.3598 43.0597 84.4309C42.5933 86.1348 44.8526 87.2152 45.8933 85.7879C49.7487 80.498 54.6565 77.3293 60.0003 77.3293Z",
    fill: "url(#paint4_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0003 77.3293C65.344 77.3293 70.2518 80.498 74.1073 85.7879C75.1479 87.2152 77.4073 86.1371 76.9409 84.4309C74.18 74.3598 69.4573 67.748 60.0003 67.748C50.5433 67.748 45.8206 74.3598 43.0597 84.4309C42.5933 86.1348 44.8526 87.2152 45.8933 85.7879C49.7487 80.498 54.6565 77.3293 60.0003 77.3293Z",
    fill: "url(#paint5_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0003 77.3293C54.6565 77.3293 49.7487 80.498 45.8933 85.7879C44.8526 87.2152 42.5933 86.1371 43.0597 84.4309C45.8206 74.3598 50.5433 67.748 60.0003 67.748C69.4573 67.748 74.18 74.3598 76.9409 84.4309C77.4073 86.1348 75.1479 87.2152 74.1073 85.7879C70.2518 80.498 65.344 77.3293 60.0003 77.3293Z",
    fill: "url(#paint6_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4223 58.7742C87.5559 58.7742 91.7176 54.6126 91.7176 49.4789C91.7176 44.3452 87.5559 40.1836 82.4223 40.1836C77.2886 40.1836 73.127 44.3452 73.127 49.4789C73.127 54.6126 77.2886 58.7742 82.4223 58.7742Z",
    fill: "url(#paint7_radial_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4223 58.7742C87.5559 58.7742 91.7176 54.6126 91.7176 49.4789C91.7176 44.3452 87.5559 40.1836 82.4223 40.1836C77.2886 40.1836 73.127 44.3452 73.127 49.4789C73.127 54.6126 77.2886 58.7742 82.4223 58.7742Z",
    fill: "url(#paint8_radial_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6566 58.7742C42.7903 58.7742 46.952 54.6126 46.952 49.4789C46.952 44.3452 42.7903 40.1836 37.6566 40.1836C32.523 40.1836 28.3613 44.3452 28.3613 49.4789C28.3613 54.6126 32.523 58.7742 37.6566 58.7742Z",
    fill: "url(#paint9_radial_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6566 58.7742C42.7903 58.7742 46.952 54.6126 46.952 49.4789C46.952 44.3452 42.7903 40.1836 37.6566 40.1836C32.523 40.1836 28.3613 44.3452 28.3613 49.4789C28.3613 54.6126 32.523 58.7742 37.6566 58.7742Z",
    fill: "url(#paint10_radial_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0244 34.7898C34.9619 32.9547 38.283 30.3789 40.8612 27.3578C42.4877 25.4523 45.5182 27.4867 44.3627 29.7133C42.0729 34.1265 38.3604 37.8484 33.5065 40.1125C28.6502 42.3765 23.4143 42.8289 18.5604 41.7461C16.1135 41.2 16.5002 37.5718 19.008 37.5508C22.9784 37.5179 27.0869 36.6273 31.0244 34.7922V34.7898Z",
    fill: "url(#paint11_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9756 34.7898C85.0381 32.9547 81.717 30.3789 79.1388 27.3578C77.5123 25.4523 74.4818 27.4867 75.6373 29.7133C77.9271 34.1265 81.6396 37.8484 86.4935 40.1125C91.3498 42.3765 96.5857 42.8289 101.44 41.7461C103.886 41.2 103.5 37.5718 100.992 37.5508C97.0217 37.5179 92.9131 36.6273 88.9756 34.7922V34.7898Z",
    fill: "url(#paint12_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.256 79.3668L94.7391 55.8496L85.9805 71.0746L110.878 95.9723C114.22 90.966 116.742 85.3691 118.256 79.3668Z",
    fill: "url(#paint13_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5109 65.377C99.5109 69.7762 95.9437 73.3434 91.5445 73.3434C87.1453 73.3434 83.5781 69.7762 83.5781 65.377C83.5781 60.9777 88.9453 53.8691 91.5445 53.8691C94.1437 53.8691 99.5109 60.9777 99.5109 65.377Z",
    fill: "url(#paint14_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5801 65.3758C83.5801 69.775 87.1473 73.3422 91.5465 73.3422C95.9457 73.3422 99.5129 69.775 99.5129 65.3758C99.5129 63.9062 98.9129 62.1344 98.0176 60.4258H85.0777C84.1824 62.1344 83.5824 63.9062 83.5824 65.3758H83.5801Z",
    fill: "url(#paint15_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5465 53.8715C90.9934 53.8715 90.316 54.1949 89.5918 54.7434V73.102C90.2176 73.259 90.8715 73.3434 91.5465 73.3434C95.9457 73.3434 99.5129 69.7762 99.5129 65.377C99.5129 60.9777 94.1457 53.8691 91.5465 53.8691V53.8715Z",
    fill: "url(#paint16_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5109 65.377C99.5109 69.7762 95.9437 73.3434 91.5445 73.3434C87.1453 73.3434 83.5781 69.7762 83.5781 65.377C83.5781 60.9777 88.9453 53.8691 91.5445 53.8691C94.1437 53.8691 99.5109 60.9777 99.5109 65.377Z",
    fill: "url(#paint17_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0887 114.293L31.6473 55.8516L22.8887 71.0766L71.4441 119.632C78.0887 118.988 84.3769 117.136 90.0887 114.295V114.293Z",
    fill: "url(#paint18_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4191 65.377C36.4191 69.7762 32.852 73.3434 28.4527 73.3434C24.0535 73.3434 20.4863 69.7762 20.4863 65.377C20.4863 60.9777 25.8535 53.8691 28.4527 53.8691C31.052 53.8691 36.4191 60.9777 36.4191 65.377Z",
    fill: "url(#paint19_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4883 65.3758C20.4883 69.775 24.0555 73.3422 28.4547 73.3422C32.8539 73.3422 36.4211 69.775 36.4211 65.3758C36.4211 63.9062 35.8211 62.1344 34.9258 60.4258H21.9859C21.0906 62.1344 20.4906 63.9062 20.4906 65.3758H20.4883Z",
    fill: "url(#paint20_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4527 53.8715C27.8996 53.8715 27.2223 54.1949 26.498 54.7434V73.102C27.1238 73.259 27.7777 73.3434 28.4527 73.3434C32.852 73.3434 36.4191 69.7762 36.4191 65.377C36.4191 60.9777 31.052 53.8691 28.4527 53.8691V53.8715Z",
    fill: "url(#paint21_linear_10831_109970)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4191 65.377C36.4191 69.7762 32.852 73.3434 28.4527 73.3434C24.0535 73.3434 20.4863 69.7762 20.4863 65.377C20.4863 60.9777 25.8535 53.8691 28.4527 53.8691C31.052 53.8691 36.4191 60.9777 36.4191 65.377Z",
    fill: "url(#paint22_linear_10831_109970)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10831_109970",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.49 31.2367) scale(82.4133 82.4133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10831_109970",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7775 50.7273) scale(75.7242 75.7242)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FE9738",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FE9738",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE9738",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FE9738",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FE9738",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FE9738",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FE9738",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FE9738",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FE9738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FE9738",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#FE9738",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FE9738",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#FE9738",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#FE9738",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FE9738",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FE9738",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#FE9738",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9738",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10831_109970",
    x1: 60.0004,
    y1: 89.1605,
    x2: 60.0004,
    y2: 78.6512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FE9636",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FE9433",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE912E",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE8D26",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FE871D",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FE8011",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FE7804",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10831_109970",
    x1: 60.0003,
    y1: 69.6113,
    x2: 60.0003,
    y2: 84.1871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10831_109970",
    x1: 60.0003,
    y1: 77.7465,
    x2: 60.0003,
    y2: 67.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#543333",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#482D2E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#332224",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2022"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10831_109970",
    x1: 54.2588,
    y1: 76.7028,
    x2: 49.1588,
    y2: 72.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#543333",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#482D2E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#332224",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2022"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10831_109970",
    x1: 65.7418,
    y1: 76.7028,
    x2: 70.8418,
    y2: 72.6973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#543333",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#482D2E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#332224",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F2022"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_10831_109970",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8621 52.3477) rotate(180) scale(11.5312 11.5313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_10831_109970",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.316 50.9156) rotate(180) scale(11.7305 11.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#563435",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F3131",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#432A2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#322123",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2F2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#312123",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3B2627",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4A2E2F",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_10831_109970",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0965 52.3477) rotate(180) scale(11.5313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A6D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6C616C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5B535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#554E56"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10831_109970",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5504 50.9156) rotate(180) scale(11.7305)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#593636",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#563435",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F3131",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#432A2B",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#322123",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#2F2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#312123",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3B2627",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4A2E2F",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593636",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10831_109970",
    x1: 33.1798,
    y1: 39.2223,
    x2: 29.4157,
    y2: 31.4504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10831_109970",
    x1: 82.6301,
    y1: 45.2462,
    x2: 89.734,
    y2: 33.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE860A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10831_109970",
    x1: 104.625,
    y1: 76.6923,
    x2: 87.6846,
    y2: 69.4056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FE9636",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FE9433",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE912E",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE8D26",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FE871D",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FE8011",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FE7804",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10831_109970",
    x1: 88.579,
    y1: 61.4917,
    x2: 96.9579,
    y2: 70.7823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8EE1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#71D5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#43C2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10831_109970",
    x1: 91.5465,
    y1: 65.1016,
    x2: 91.5465,
    y2: 72.7258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0593FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0492FC",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0491FC",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#048FFC",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#038DFC",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#028AFC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0286FC",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0182FC",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10831_109970",
    x1: 90.8223,
    y1: 63.6962,
    x2: 99.323,
    y2: 62.8455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0593FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0492FC",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0491FC",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#048FFC",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#038DFC",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#028AFC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0286FC",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0182FC",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10831_109970",
    x1: 93.7376,
    y1: 66.6902,
    x2: 97.9891,
    y2: 70.7589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#99E6FC",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#99E6FC",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#99E6FC",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#99E6FC",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#99E6FC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#99E6FC",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#99E6FC",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#99E6FC",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99E6FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10831_109970",
    x1: 35.2152,
    y1: 78.5822,
    x2: 22.2237,
    y2: 71.2955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FE9636",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FE9433",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FE912E",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE8D26",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FE871D",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FE8011",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#FE7804",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10831_109970",
    x1: 25.486,
    y1: 61.4905,
    x2: 33.8649,
    y2: 70.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#8EE1FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#71D5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#43C2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08A9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10831_109970",
    x1: 28.4547,
    y1: 65.1016,
    x2: 28.4547,
    y2: 72.7258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0593FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0492FC",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0491FC",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#048FFC",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#038DFC",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#028AFC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0286FC",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0182FC",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10831_109970",
    x1: 27.7309,
    y1: 63.6962,
    x2: 36.2293,
    y2: 62.8455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0593FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0492FC",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#0491FC",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#048FFC",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#038DFC",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#028AFC",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0286FC",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0182FC",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10831_109970",
    x1: 30.6446,
    y1: 66.689,
    x2: 34.8962,
    y2: 70.7577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99E6FC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#99E6FC",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#99E6FC",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#99E6FC",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#99E6FC",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#99E6FC",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#99E6FC",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#99E6FC",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#99E6FC",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#99E6FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10831_109970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCry);
export default __webpack_public_path__ + "static/media/Cry.2f9bd6728f5f10c38f5a5e7a2b601572.svg";
export { ForwardRef as ReactComponent };